import { atom } from "recoil";
import { CheckoutCompleted } from "../model";

export const lastCheckoutCompletedState = atom<CheckoutCompleted | undefined>({
  key: "lastCheckoutCompletedState",
  default: undefined
})